/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import { CustomFieldsFragmentDoc } from '../custom-fields/CustomFieldsBox.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCrmPersonMutationVariables = Types.Exact<{
  input: Types.CreateCrmPersonInput;
}>;


export type CreateCrmPersonMutation = { createCrmPerson: { __typename: 'CreateCrmPersonResult', crmPerson: { __typename: 'CrmPerson', id: string } } };

export type ModifyCrmUserMutationVariables = Types.Exact<{
  users: Array<Types.CrmUserModifyInput>;
}>;


export type ModifyCrmUserMutation = { modifyCrmUser: { __typename: 'CrmUserModifyResult', users: Array<{ __typename: 'CrmPerson', id: string, notices: string, customTags: Array<string>, jobTitle: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string>, email: any, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any, dataType: Types.CustomFieldDataType, group: string }> }> } };

export type CrmPersonDetailsFragment = { __typename: 'CrmPerson', id: string, notices: string, customTags: Array<string>, jobTitle: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string>, email: any, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any, dataType: Types.CustomFieldDataType, group: string }> };

export const CrmPersonDetailsFragmentDoc = gql`
    fragment CrmPersonDetails on CrmPerson {
  id
  notices
  customTags
  jobTitle
  homeAddress {
    ...AddressDetails__Address
  }
  title
  description
  website
  isMeister
  familyname
  firstname
  fullname
  locale
  categories
  email
  phones {
    id
    main
    type
    number
  }
  avatar {
    ...AttachmentSnapshot
  }
  ...CustomFields
}
    ${AddressDetails__AddressFragmentDoc}
${AttachmentSnapshotFragmentDoc}
${CustomFieldsFragmentDoc}`;
export const CreateCrmPersonDocument = gql`
    mutation CreateCrmPerson($input: CreateCrmPersonInput!) {
  createCrmPerson(input: $input) {
    crmPerson {
      id
    }
  }
}
    `;
export type CreateCrmPersonMutationFn = Apollo.MutationFunction<CreateCrmPersonMutation, CreateCrmPersonMutationVariables>;

/**
 * __useCreateCrmPersonMutation__
 *
 * To run a mutation, you first call `useCreateCrmPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCrmPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCrmPersonMutation, { data, loading, error }] = useCreateCrmPersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCrmPersonMutation(baseOptions?: Apollo.MutationHookOptions<CreateCrmPersonMutation, CreateCrmPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCrmPersonMutation, CreateCrmPersonMutationVariables>(CreateCrmPersonDocument, options);
      }
export type CreateCrmPersonMutationHookResult = ReturnType<typeof useCreateCrmPersonMutation>;
export type CreateCrmPersonMutationResult = Apollo.MutationResult<CreateCrmPersonMutation>;
export type CreateCrmPersonMutationOptions = Apollo.BaseMutationOptions<CreateCrmPersonMutation, CreateCrmPersonMutationVariables>;
export const ModifyCrmUserDocument = gql`
    mutation ModifyCrmUser($users: [CrmUserModifyInput!]!) {
  modifyCrmUser(input: $users) {
    users {
      id
      ...CrmPersonDetails
    }
  }
}
    ${CrmPersonDetailsFragmentDoc}`;
export type ModifyCrmUserMutationFn = Apollo.MutationFunction<ModifyCrmUserMutation, ModifyCrmUserMutationVariables>;

/**
 * __useModifyCrmUserMutation__
 *
 * To run a mutation, you first call `useModifyCrmUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyCrmUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyCrmUserMutation, { data, loading, error }] = useModifyCrmUserMutation({
 *   variables: {
 *      users: // value for 'users'
 *   },
 * });
 */
export function useModifyCrmUserMutation(baseOptions?: Apollo.MutationHookOptions<ModifyCrmUserMutation, ModifyCrmUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyCrmUserMutation, ModifyCrmUserMutationVariables>(ModifyCrmUserDocument, options);
      }
export type ModifyCrmUserMutationHookResult = ReturnType<typeof useModifyCrmUserMutation>;
export type ModifyCrmUserMutationResult = Apollo.MutationResult<ModifyCrmUserMutation>;
export type ModifyCrmUserMutationOptions = Apollo.BaseMutationOptions<ModifyCrmUserMutation, ModifyCrmUserMutationVariables>;